import { yupToFormErrors } from 'formik'
import type { Schema } from 'yup'

export * from './dateHelpers'
export * from './numberHelpers'
export * from './successHelpers'
export * from './labelHelpers'

export { arrayWithItemFirst } from './array-with-item-first'
export { defaultUserCountryCode } from './default-user-country-code'
export { getCountryFromBrowserLanguage } from './get-country-from-browser-language'
export { getLanguageFromLocale } from './get-language-from-locale'
export { languageToLocale } from './language-to-locale'
export { topLevelDomain } from './top-level-domain'

export const insertIf = <T>(condition: boolean, ...elements: T[]) => (condition ? elements : [])

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const validateSchema = async <T extends object>(validationSchema: Schema<T>, values: any) => {
  try {
    await validationSchema.validate(values, { abortEarly: false })
    return {}
  } catch (yupError) {
    return yupToFormErrors(yupError)
  }
}
